import { useContentSelector } from '@wajeez-web/stores/content';

import {
  ComponentFormBuilder,
  InputFieldWithSelectorOptions,
} from './ComponentFormBuilder';
import { Languages } from '@wajeez-web/core/utils';

interface ComponentCreateFormProps {
  componentTypeId: number | undefined;
  inputFieldsWithSelectorOptions: InputFieldWithSelectorOptions[] | undefined;
  onSubmit: () => void;
  onItemTemplateCloneSaveAndEdit: (itemTemplateId: string) => void;
  onItemTemplateEditButtonClick: (itemTemplateId: string) => void;
  onCancel?: () => void;
}

export const ComponentCreateForm = ({
  componentTypeId,
  inputFieldsWithSelectorOptions,
  onSubmit,
  onItemTemplateCloneSaveAndEdit,
  onItemTemplateEditButtonClick,
  onCancel,
}: ComponentCreateFormProps) => {
  const componentType = useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypeById
  );
  const componentTypeData = componentType.data;

  const componentLookupsByComponentTypeIds = useContentSelector(
    ({ components }) => components.componentLookupsByComponentTypeId
  );

  return (
    <div className="w-full">
      <ComponentFormBuilder
        type="Create"
        dynamicFields={inputFieldsWithSelectorOptions}
        profiles={[
          {
            languageId: Languages.AR,
            fields: inputFieldsWithSelectorOptions,
          },
        ]}
        componentTypeId={componentTypeId}
        onSubmit={onSubmit}
        onItemTemplateCloneSaveAndEdit={onItemTemplateCloneSaveAndEdit}
        onItemTemplateEditButtonClick={onItemTemplateEditButtonClick}
        itemTemplateField={
          componentTypeData!.contentItemType === 1
            ? {
                name: 'itemTemplate',
                label: 'Item Template',
                selectOptions: componentLookupsByComponentTypeIds.typeIds[
                  JSON.stringify(componentTypeData!.allowedItemTemplateTypes)
                ]?.data.map((d) => {
                  return {
                    value: d.id,
                    label: d.referenceName,
                  };
                }),
              }
            : undefined
        }
        onCancel={onCancel}
      />
    </div>
  );
};
